const GOAL_KEY = 'qnaread.dailyReviewGoal';
const SOURCE_KEY = 'qnaread.practiceSource';

export function getDailyReviewGoal() {
  const raw = localStorage.getItem(GOAL_KEY);
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? Math.min(n, 200) : 10;
}

export function setDailyReviewGoal(value) {
  const n = Math.max(1, Math.min(200, Number(value) || 10));
  localStorage.setItem(GOAL_KEY, String(n));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('qnaread:learning-prefs'));
  }
  return n;
}

export function getPracticeSource() {
  const v = localStorage.getItem(SOURCE_KEY);
  return v === 'library' ? 'library' : 'saved';
}

export function setPracticeSource(source) {
  const v = source === 'library' ? 'library' : 'saved';
  localStorage.setItem(SOURCE_KEY, v);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('qnaread:learning-prefs'));
  }
  return v;
}

